import { Strophe } from 'react-strophe'

const parser = new DOMParser()
const parserErrorNS = parser.parseFromString('invalid', 'text/xml').getElementsByTagName('parsererror')[0].namespaceURI

/*
  This method will convert an xml string to an XMPP payload.
*/
export const toStanza = (xmlString) => {
  const node = parser.parseFromString(xmlString, 'text/xml')
  if (node.getElementsByTagNameNS(parserErrorNS, 'parsererror').length) {
    throw new Error(`Parser Error: ${xmlString}`)
  }
  return node.firstElementChild
}

export const getAttributes = (stanza) => {
  return stanza.getAttributeNames().reduce((acc, name) => {
    acc[name] = Strophe.xmlunescape(stanza.getAttribute(name))
    return acc
  }, {})
}
